'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Shows tooltip when text content overflows out of the container
 * */
var TextWithTooltip = function TextWithTooltip(_ref) {
	var style = _ref.style,
	    className = _ref.className,
	    title = _ref.title,
	    innerHTML = _ref.innerHTML;

	var containerRef = (0, _react.useRef)(null);
	var contentRef = (0, _react.useRef)(null);

	var _useState = (0, _react.useState)(false),
	    isOverflowing = _useState[0],
	    setIsOverflowing = _useState[1];

	(0, _react.useEffect)(function () {
		var container = containerRef.current;
		var content = contentRef.current;
		if (container && content) {
			var containerWidth = container.offsetWidth;
			var contentWidth = content.scrollWidth;

			setIsOverflowing(contentWidth > containerWidth);
		}
	}, [innerHTML, title]);

	return _react2.default.createElement(
		'div',
		{ title: isOverflowing ? title : '', ref: containerRef },
		_react2.default.createElement('div', {
			className: className,
			style: style,
			ref: contentRef,
			dangerouslySetInnerHTML: {
				__html: innerHTML
			}
		})
	);
};

TextWithTooltip.propTypes = {
	title: _propTypes.string,
	className: _propTypes.string,
	style: _types2.default.style,
	innerHTML: _propTypes.string.isRequired
};

exports.default = TextWithTooltip;